import { render, staticRenderFns } from "./forumRevenue.vue?vue&type=template&id=4b0a299e&scoped=true&"
import script from "./forumRevenue.vue?vue&type=script&lang=js&"
export * from "./forumRevenue.vue?vue&type=script&lang=js&"
import style0 from "./forumRevenue.vue?vue&type=style&index=0&id=4b0a299e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0a299e",
  null
  
)

export default component.exports